module.exports = __webpack_public_path__ + "img/Trillionaire-2.8fe2a611.gif";